const getCalendarLoadersForTheme = (theme: string) => {
  switch (theme ? theme.toLowerCase() : "") {
    case "winterwonderland": {
      return {
        firstImage: "/loader-images/rainbow.svg",
        secondImage: "/loader-images/snowflake.svg",
        thirdImage: "/loader-images/night.svg",
      };
    }
    case "nightrider": {
      return {
        firstImage: "/loader-images/night.svg",
        secondImage: "/loader-images/champagne.svg",
        thirdImage: "/loader-images/music-notes.svg",
      };
    }
    case "halloween": {
      return {
        firstImage: "/loader-images/bat.svg",
        secondImage: "/loader-images/pumpkin.svg",
        thirdImage: "/loader-images/ghost.svg",
      };
    }
    default: {
      return {
        firstImage: "/loader-images/bergochdalbana.svg",
        secondImage: "/loader-images/glass.svg",
        thirdImage: "/loader-images/musik.svg",
      };
    }
  }
};

export { getCalendarLoadersForTheme };
